<template>
    <span class="base-count-badge scaffold-details-bold">{{ displayCount }}</span>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
    defineProps<{
        count: number;
        max?: number;
    }>(),
    {
        max: 99,
    },
);

const displayCount = computed(() => (props.count > props.max ? `${props.max}+` : `${props.count}`));
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .base-count-badge {
        @apply inline-flex h-4.5 min-w-4.5 shrink-0 items-center justify-center rounded-full bg-count-badge-bg px-1 text-count-badge-text tabular-nums ring-2 ring-count-badge-ring;
    }
}
</style>
